import { createAction, props } from '@ngrx/store';
import {
  TicketCategory,
  TicketCategoryCreateRequest,
  TicketCategoryEditRequest,
} from '../../interfaces/inventory/inventory-management-interface';

// Ask to load categories for a specific store
export const loadTicketCategoriesByStore = createAction('[Ticket Categories] Load By Store', props<{ storeId: number }>());

// Signal success, carrying back both the storeId and the fetched categories
export const loadTicketCategoriesByStoreSuccess = createAction(
  '[Ticket Categories] Load By Store Success',
  props<{ storeId: number; categories: TicketCategory[] }>()
);

// Signal failure, carrying an error message
export const loadTicketCategoriesByStoreFailure = createAction('[Ticket Categories] Load By Store Failure', props<{ error: string }>());

// Load all categories
export const loadAllTicketCategories = createAction('[Ticket Categories] Load All');

// Signal success for loading all categories
export const loadAllTicketCategoriesSuccess = createAction(
  '[Ticket Categories] Load All Success',
  props<{ categories: TicketCategory[] }>()
);

// Signal failure for loading all categories
export const loadAllTicketCategoriesFailure = createAction('[Ticket Categories] Load All Failure', props<{ error: string }>());

export const createTicketCategorySuccess = createAction('[Ticket Categories] Create Success', props<{ category: TicketCategory }>());

export const editTicketCategorySuccess = createAction('[Ticket Categories] Edit Success', props<{ category: TicketCategory }>());
